export default "__VITE_ASSET__D_DkbY7r__"